import capitalize from 'lodash/capitalize';



export const imageSources = {
  collection: 'collection',
  images: 'images',
} as const;

export type ImageSource =
    typeof imageSources[keyof typeof imageSources];

interface ImageSourceOption {
    label: string;
    value: ImageSource;
}

export const imageSourceOptions: ImageSourceOption[] = Object.entries(
  imageSources,
).map(([ key, value ]) => ({
  label: capitalize(key),
  value,
}));
